const exportedObject = {
  getPrecertificacionData: {},
  getPrecertificacionLoading: false,
  getPrecertificacionError: null,

  confirmarPrecertificacionData: {},
  confirmarPrecertificacionLoading: false,
  confirmarPrecertificacionError: null,

  cancelarPrecertificacionData: {},
  cancelarPrecertificacionLoading: false,
  cancelarPrecertificacionError: null
};

export default exportedObject;